export default __webpack_public_path__ + "static/media/play-button.fe134c3c.svg";